import { render, staticRenderFns } from "./courier.vue?vue&type=template&id=a45f8b30&"
import script from "./courier.vue?vue&type=script&lang=js&"
export * from "./courier.vue?vue&type=script&lang=js&"
import style0 from "./courier.vue?vue&type=style&index=0&id=a45f8b30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports